import { Modal } from "antd";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import { PurchaseLicenseCodeSelector } from "./PurchaseLicenseCodeSelector";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import useGet from "../../../global/hooks/useGet";
import { codetypeOptions } from "../../../utils/Common";
import { InfoChip } from "../../../global/components/InfoChip";

const PurchaseLicenseItemModal = ({
  open,
  setOpen,
  purchaseId,
  editingItem,
  setEditingItem,
  existingItems = [],
  onSaved,
  onPick,
  oemNo = null,
  isOemLicense = false,
  codeType = null,
}) => {
  const isEdit = editingItem?.ItemNo != null;

  const handleClose = () => setOpen(false);

  const { data: oemOptionsData } = useGet(
    open && isOemLicense && oemNo != null
      ? `${process.env.REACT_APP_API_URL}/api/dealers/options/`
      : null,
  );
  const oemOptions = getModifiedResponse(oemOptionsData, "oems");
  const oemLabel = oemOptions?.find(
    (o) => Number(o.value) === Number(oemNo),
  )?.label;
  const codeTypeLabel =
    codeType != null
      ? codetypeOptions?.find((o) => o.value === codeType)?.label
      : undefined;
  const effectiveOemNo = isOemLicense ? oemNo : null;

  return (
    <Modal
      open={open}
      closable={false}
      onCancel={handleClose}
      afterClose={() => setEditingItem?.(null)}
      footer={null}
      width={1000}
      centered
      destroyOnClose
      title={
        <div className="flex items-center justify-between gap-3 bg-gray-200 p-2 rounded-md">
          <div className="flex items-center">
            <PaymentIcon className="text-[18px] text-black" />
            <span className="text-[14px] font-[Poppins] text-black ml-2">
              {isEdit ? "Edit License item" : "Add License item"}
            </span>
          </div>
          <div className="flex items-center gap-2 font-normal">
            {isOemLicense ? (
              oemNo != null && oemLabel ? (
                <InfoChip>{oemLabel}</InfoChip>
              ) : null
            ) : (
              <InfoChip>Generic</InfoChip>
            )}
            {codeTypeLabel ? <InfoChip>{codeTypeLabel}</InfoChip> : null}
          </div>
        </div>
      }
    >
      <PurchaseLicenseCodeSelector
        purchaseId={purchaseId}
        existingItems={existingItems}
        editingItem={editingItem}
        onCancel={handleClose}
        onSaved={onSaved}
        onPick={onPick}
        oemNo={effectiveOemNo}
        isOemLicense={isOemLicense}
        codeType={codeType}
        scopeByOem
      />
    </Modal>
  );
};

export default PurchaseLicenseItemModal;
